export default {
    authorizing_user:false,
    generate_expense_user:false,
    notifications: []
}



// WEBPACK FOOTER //
// ./src/modules/notifications/state.js